export default "__VITE_PUBLIC_ASSET__ddf20d04__"